import { SvgIcon, SvgIconProps } from '@mui/material';
import { FC } from 'react';

const FactDateIcon: FC<SvgIconProps> = props => {
  return (
    <SvgIcon {...props}>
      <svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.8333 0C11.0374 2.69255e-05 11.2344 0.0749635 11.387 0.210596C11.5395 0.346229 11.637 0.533124 11.6608 0.735833L11.6667 0.833333V1.66667H12.5C13.1377 1.66663 13.7513 1.91027 14.2152 2.34774C14.6792 2.7852 14.9584 3.38342 14.9958 4.02L15 4.16667V14.1667C15 14.8043 14.7564 15.4179 14.3189 15.8819C13.8815 16.3458 13.2832 16.6251 12.6467 16.6625L12.5 16.6667H2.5C1.86232 16.6667 1.24874 16.4231 0.784783 15.9856C0.320828 15.5481 0.0415771 14.9499 0.00416677 14.3133L3.88371e-09 14.1667V4.16667C-3.55181e-05 3.52899 0.243604 2.9154 0.68107 2.45145C1.11854 1.98749 1.71676 1.70824 2.35333 1.67083L2.5 1.66667H3.33333V0.833333C3.33357 0.620934 3.4149 0.41664 3.56071 0.262193C3.70651 0.107746 3.90579 0.0148042 4.11783 0.00235657C4.32986 -0.010091 4.53865 0.0588955 4.70153 0.195221C4.8644 0.331546 4.96908 0.52492 4.99417 0.735833L5 0.833333V1.66667H10V0.833333C10 0.61232 10.0878 0.400358 10.2441 0.244078C10.4004 0.0877973 10.6123 0 10.8333 0ZM13.3333 5.83333H1.66667V13.8542C1.66667 14.4417 1.98833 14.9258 2.4025 14.9925L2.5 15H12.5C12.9275 15 13.28 14.5583 13.3275 13.9875L13.3333 13.8542V5.83333Z"
          fill="var(--mui-palette-text-secondary)"
        />
        <path
          d="M6.44531 13.3333H5.78125V7.62238H8.96094V8.20831H6.44531V10.3021H8.80859V10.8841H6.44531V13.3333Z"
          fill="var(--mui-palette-text-secondary)"
        />
      </svg>
    </SvgIcon>
  );
};

export default FactDateIcon;
